import script from "./cert-manager.io.certificate.vue?vue&type=script&setup=true&lang=ts"
export * from "./cert-manager.io.certificate.vue?vue&type=script&setup=true&lang=ts"

import "./cert-manager.io.certificate.vue?vue&type=style&index=0&id=70af9d79&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70af9d79"]])

export default __exports__